module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "app"
    }
  }, [(_vm.ready && _vm.requiresAuth) ? _c('sidebar') : _vm._e(), _vm._v(" "), (_vm.ready && _vm.requiresAuth) ? _c('navigation') : _vm._e(), _vm._v(" "), (_vm.ready) ? _c('div', {
    class: _vm.getMainClass()
  }, [_c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('router-view', {
    key: this.$route.path
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "spinner"
    }
  }, [_c('spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.ready),
      expression: "!ready"
    }],
    style: (_vm.ready ? 'animation-play-state:paused' : '')
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-40c83d6a!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/App.vue
// module id = 728
// module chunks = 1